import { render, staticRenderFns } from "./baseBreadcrumb.vue?vue&type=template&id=c807d718&scoped=true&"
import script from "./baseBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./baseBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./baseBreadcrumb.vue?vue&type=style&index=0&id=c807d718&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c807d718",
  null
  
)

export default component.exports